import React, {useEffect, useState} from 'react';
import {Form, Radio, Card} from "antd";
import { Input } from 'antd';
import emiter, {_EVENTS, EVENT_CARRENTAL_ROLE_OPEN_DETAIL} from "../../../../../events";
interface PropsType {
    enums: any
}


const ScopeOfCompensation: React.FC<PropsType> = (props) => {
    const { enums } = props
    const [level, setLevel ] = useState<any>(null);
    const onLevelChange = (val:any) => {
      setLevel(val)
    }

    useEffect(() => {
      emiter.on(_EVENTS.PRODUCT_PRICE.VALUE_ADDED_PRICE.CHANGE_LEVEL, onLevelChange)
      return () => {
        emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.VALUE_ADDED_PRICE.CHANGE_LEVEL)
      }
    }, []);

  return (
        <>
            <Form.Item
                labelCol={{ span: 4, }}
                rules={[{required: true, message: '请输入价格'}]}
                label='起赔额' >
                <Card size='small'>
                    <Form.Item name='guarantee_deductible_amount' noStyle={true}>
                        <Input
                            disabled={true}
                            addonAfter='元'
                            allowClear={true}
                            placeholder='请输价格'
                            style={{width: '300px'}}
                        ></Input>
                    </Form.Item>
                    <div style={{height: '30px', display: 'flex', alignItems: 'center'}}>
                         <span style={{marginRight: '8px'}}>
                              是否包含轮胎损失
                        </span>

                        <Form.Item
                            style={{marginLeft: '8px'}}
                            rules={[{required: true, message: '请选择是否包含轮胎损失'}]}
                            noStyle
                            name='contains_tyres_loss'>
                            <Radio.Group
                              disabled={[3].includes(level)}
                              options={[
                                {
                                    label: '包含',
                                    value: 1
                                },
                                {
                                    label: '不包含',
                                    value: 2
                                }
                            ]} style={{width: '300px'}}>

                            </Radio.Group>
                        </Form.Item>
                    </div>
                    <div style={{height: '30px', display: 'flex', alignItems: 'center'}}>
                        <span    style={{marginRight: '8px'}}>
                              是否包含玻璃损失
                        </span>

                        <Form.Item

                            rules={ [{ required: true , message: '请选择是否包含玻璃损失'}]}
                            noStyle name='contains_glass_loss'>
                            <Radio.Group
                              disabled={[2, 3].includes(level)}
                              options={[
                                {
                                    label: '包含',
                                    value: 1
                                },
                                {
                                    label: '不包含',
                                    value: 2
                                }
                            ]} style={{width: '300px'}}>

                            </Radio.Group>
                        </Form.Item>
                    </div>
                </Card>

            </Form.Item>
        </>
    )
}

export default ScopeOfCompensation;


